import React, { useEffect, useState } from "react";
import { getFinance } from "@/lib/api";
import { BarChart, Bar, ResponsiveContainer, XAxis, YAxis, Tooltip, Cell } from "recharts";

export default function FinancePanel({ refreshKey }) {
  const [data, setData] = useState(null);
  useEffect(() => { getFinance().then(setData).catch(() => {}); }, [refreshKey]);

  if (!data) return <div className="rc-panel p-4 h-full"><div className="rc-label rc-blink">LOADING FINANCE</div></div>;

  const chartData = data.entries.map(e => ({ name: e.category, amount: Math.abs(e.amount), type: e.type }));

  return (
    <div className="rc-panel p-4 h-full flex flex-col" data-testid="finance-panel">
      <div className="flex items-center justify-between mb-3">
        <div className="rc-label">// INTAKE · OUTGOINGS</div>
        <div className="rc-label text-[9px]">MTD</div>
      </div>

      <div className="grid grid-cols-3 gap-2 mb-3">
        <Cell2 label="INCOME" value={`£${data.income.toLocaleString()}`} color="var(--rc-success)" testid="fin-income" />
        <Cell2 label="OUTGOING" value={`£${Math.abs(data.outgoing).toLocaleString()}`} color="var(--rc-danger)" testid="fin-outgoing" />
        <Cell2 label="NET" value={`£${data.net.toLocaleString()}`} color="var(--rc-gold)" testid="fin-net" />
      </div>

      <div className="h-28 mb-3">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={chartData} margin={{ top: 4, right: 4, left: 0, bottom: 0 }}>
            <XAxis dataKey="name" tick={{ fill: "#a88554", fontSize: 9 }} axisLine={{ stroke: "#ffb80044" }} tickLine={false} />
            <YAxis hide />
            <Tooltip contentStyle={{ background: "#0a0703", border: "1px solid #ffb80044", fontSize: 11 }} labelStyle={{ color: "#ffb800" }} />
            <Bar dataKey="amount">
              {chartData.map((entry, idx) => (
                <Cell key={idx} fill={entry.type === "income" ? "#7fffaa" : "#ff8a00"} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>

      <div className="flex-1 overflow-y-auto space-y-1">
        {data.entries.map(e => (
          <div key={e.id} className="flex items-center justify-between text-xs border-b border-[var(--rc-gold-dim)] py-1" data-testid={`fin-entry-${e.id}`}>
            <div>
              <span className={`text-[9px] tracking-widest ${e.type === "income" ? "text-[var(--rc-success)]" : "text-[var(--rc-danger)]"}`}>{e.type === "income" ? "+" : "-"}</span>
              <span className="ml-2 font-mono">{e.category}</span>
            </div>
            <span className="tabular-nums">£{Math.abs(e.amount).toLocaleString()}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

function Cell2({ label, value, color, testid }) {
  return (
    <div className="border border-[var(--rc-gold-dim)] p-2" data-testid={testid}>
      <div className="rc-label text-[9px]">{label}</div>
      <div className="font-display text-sm mt-1 tabular-nums truncate" style={{ color }}>{value}</div>
    </div>
  );
}
